import { useStateContext } from "./useStateContext";

/**
 * This hook provides an easy way to get application state for the correct version
 * (v1 vs v2) without having to check which version we are using. It'll always provide
 * the correct state for the given version. It also returns `dispatch`, which is only
 * relevant for v2 (but harmless for v1).
 */
export function useAppState() {
  const { state, dispatch } = useStateContext();

  return {
    state,
    dispatch,
  };
}
